import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { lazy } from 'react';
import WidgetType from '@jbrowse/core/pluggableElementTypes/WidgetType';
import Plugin from '@jbrowse/core/Plugin';
import { configSchema as ConfigurationEditorConfigSchema, HeadingComponent as ConfigurationEditorHeadingComponent, stateModelFactory as ConfigurationEditorStateModelFactory } from './ConfigurationEditorWidget';
import FromConfigAdapterF from './FromConfigAdapter';
import FromConfigRegionsAdapterF from './FromConfigRegionsAdapter';
import FromConfigSequenceAdapterF from './FromConfigSequenceAdapter';
import RefNameAliasAdapterF from './RefNameAliasAdapter';
var LazyConfigurationEditorComponent = lazy(function () {
  return import('./ConfigurationEditorWidget/components/ConfigurationEditor');
});
var _default = /*#__PURE__*/function (_Plugin) {
  _inherits(_default, _Plugin);
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
    _this.name = 'ConfigurationPlugin';
    return _this;
  }
  _createClass(_default, [{
    key: "install",
    value: function install(pluginManager) {
      FromConfigAdapterF(pluginManager);
      FromConfigRegionsAdapterF(pluginManager);
      FromConfigSequenceAdapterF(pluginManager);
      RefNameAliasAdapterF(pluginManager);
      pluginManager.addWidgetType(function () {
        return new WidgetType({
          name: 'ConfigurationEditorWidget',
          HeadingComponent: ConfigurationEditorHeadingComponent,
          configSchema: ConfigurationEditorConfigSchema,
          stateModel: ConfigurationEditorStateModelFactory(pluginManager),
          ReactComponent: LazyConfigurationEditorComponent
        });
      });
    }
  }]);
  return _default;
}(Plugin);
export { _default as default };
export { default as JsonEditor } from './ConfigurationEditorWidget/components/JsonEditor';
export { LazyConfigurationEditorComponent as ConfigurationEditor };